import React, { Component } from 'react'
import { Col, Button, Form } from "react-bootstrap";
import "./_lecturerTimeTable.scss"
import moment from "moment";
import DateBlock from '../home/DateBlock';
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import PeriodCreationModal from './period_creation_popup/PeriodCreationModal';
import TimeTableCreationModal from './timetable_creation_popup/timeTableCreationModal';
import { LecturerTimeTableShimmer } from './LecturerTimeTableShimmer';
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import SelectDropdown from './SelectDropdown';
import AcademiaSchedule from './AcademiaSchedule';
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";
import { attachModuleGuard, AccessDeniedModal, AccessDeniedCard } from "../../../utils/moduleGuard";

// /lecturer-timeTable → "Lecturer_timetable" (the key the sidebar gates on via
// moduleRestrictions.Lecturer_timetable). Match on module_key only, never module_name:
// the sidebar group name is shared by sibling modules, and can() grants an action when
// ANY matched row allows it — matching the group would let another module's grant leak in.
const LECTURER_TIMETABLE_MODULE = ["Lecturer_timetable"];

// ── Expense-style filter services ────────────────────────────────────────────
// Branches (with their sections) and the institution class list, fetched the
// same way the Expense / Document Services modules do.
const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                section_name
            }
        }
    }
`;

const GET_EXAM_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;

const GET_EMPLOYEES = gql`
    query getEmployees($institute_id: Int, $branch_id: Int) {
        getEmployees(institute_id: $institute_id, branch_id: $branch_id) {
            employee_id
            employee_name
        }
    }
`;

const SAVE_TIMETABLE_SUBSTITUTION = gql`
    mutation saveTimetableSubstitution($params: SaveTimetableSubstitutionInput!) {
        saveTimetableSubstitution(params: $params)
    }
`;

const DAY_TYPE_META = {
    1: { label: "Regular Day",  color: "#1976d2", bg: "#e3f2fd", icon: "fas fa-book-open" },
    2: { label: "Exam Day",     color: "#f57c00", bg: "#fff3e0", icon: "fas fa-pen-nib"   },
    3: { label: "Event Day",    color: "#2e7d32", bg: "#e8f5e9", icon: "fas fa-star"       },
    4: { label: "Holiday",      color: "#c62828", bg: "#ffebee", icon: "fas fa-umbrella-beach" },
};

class LecturerTimeTableHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Not user-picked any more: derived from the branch that owns the chosen
            // Section. The header (NavbarOne) decides which branches are in scope.
            branch_id: "",
            class_id: "",
            exam_id: "",
            section_id: "",
            employee_id: "",
            classError: "",
            sectionError: "",
            dateError: "",
            loader: 0,
            startDateCalender: moment(new Date()).subtract(5, "days").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
            filteredData: [],
            filterValue: '',
            lecturer_time_table: [],
            tableHeading: [],
            noDateError: "",
            searchValue: "",
            periodCreationModal: false,
            timeTableCreationModal: false,
            branches: [],       // raw getBranches result (with sections)
            allClasses: [],     // raw getExamClasses result
            getClasses: [],     // class dropdown options [{value,label}]
            getSections: [],    // section dropdown options [{value,label}]
            employees: [],      // employee dropdown options [{value,label}]
            scheduleRole: Cookies.get("userlevel") === "4" ? "student" : "teacher",
            defaultvalue: 0,
            activeTab: "grid",
            accessDeniedShow: false,
            // ── Substitution modal state ──────────────────────────────
            showSubstituteModal: false,
            substituteTargetPeriod: null,  // { dateStr, class_period_id, timetable_id, day_of_week, slot_id, original_teacher_id, subject_name }
            selectedSubstituteEmpId: "",
            substitutionReason: "",
            substitutionLoading: false,
            substitutionError: "",
            // Map of "dateStr_slotId" → { substitute_id, substitute_name } for badge display
            substitutionMap: {},
        }

        this.guard = attachModuleGuard(this, LECTURER_TIMETABLE_MODULE);
    }

    componentDidMount() {
        // is_view === 0 → don't fetch the branch/class filter data. render() returns the
        // Access Denied card, so bailing here keeps the page data off the wire.
        if (!this.guard.canView()) return;

        this.fetchBranches();
        this.fetchClasses();
        // Branch comes from the header (NavbarOne) — re-scope the branch list, which
        // is what the Class/Section options and the lecturer list derive from.
        this.offBranchScope = onBranchScopeChange(() => this.fetchBranches());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    // The two write entry points (Period Creation + TimeTable Creation). Gating the
    // openers stops the create flow before its modal appears; the buttons stay visible
    // and clickable, and a denied role gets the Access Denied modal instead.
    openPeriodCreation = () => {
        if (!this.guard.requireEdit()) return;
        this.setState({ periodCreationModal: true });
    };

    openTimeTableCreation = () => {
        if (!this.guard.requireEdit()) return;
        this.setState({ timeTableCreationModal: true });
    };

    // Branches (with sections) — same service the Expense module uses.
    fetchBranches = async () => {
        try {
            const institution_id = parseInt(Cookies.get("institutionid"));
            const res = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id },
                fetchPolicy: "network-only",
            });
            // The header's branch selection IS this page's branch filter, and it
            // never widens past the branches the user is authorized for.
            const branches = scopeBranches(res.data.getBranches || []);
            this.setState({ branches }, () => {
                this.rebuildClassOptions();
                this.fetchEmployees();
            });
        } catch (e) {
            console.error("getBranches failed", e);
        }
    };

    // Every section across the branches the header currently has in scope.
    scopedSections = () =>
        this.state.branches.flatMap((b) =>
            (b.sections || []).map((s) => ({ ...s, branch_id: b.id }))
        );

    // The branch that owns a section — the queries below all take a single
    // branch_id, and a section belongs to exactly one branch.
    branchIdForSection = (sectionId) => {
        const sec = this.scopedSections().find((s) => String(s.id) === String(sectionId));
        return sec ? String(sec.branch_id) : "";
    };

    // Class options span every in-scope branch (this used to be "classes of the one
    // branch picked in the local Branch dropdown"). Any Class/Section chosen before
    // the scope narrowed is dropped if it is no longer available.
    rebuildClassOptions = () => {
        const classIds = [...new Set(this.scopedSections().map((s) => Number(s.class_id)))];
        const getClasses = this.state.allClasses
            .filter((c) => classIds.includes(Number(c.id)))
            .map((c) => ({ value: c.id, label: c.class }));

        this.setState((prev) => {
            const classStillValid = getClasses.some((c) => String(c.value) === String(prev.class_id));
            if (!classStillValid) {
                return {
                    getClasses, getSections: [], class_id: "", section_id: "", exam_id: "",
                    branch_id: "", lecturer_time_table: [], tableHeading: [], noDateError: "",
                };
            }
            return { getClasses };
        });
    };

    // Institution class list — same service the Expense / Document modules use.
    fetchClasses = async () => {
        try {
            const res = await this.props.client.query({
                query: GET_EXAM_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });
            this.setState({ allClasses: res.data.getExamClasses || [] });
        } catch (e) {
            console.error("getExamClasses failed", e);
        }
    };

    // branchId is optional: with a Section chosen we ask for just that branch,
    // otherwise the header's whole scope is fanned out and the results merged.
    fetchEmployees = async (branchId = null) => {
        try {
            const institute_id = parseInt(Cookies.get("institutionid"));
            const loggedInEmpId = Cookies.get("id") || Cookies.get("employee_id");
            const loggedInName = Cookies.get("username");

            const branchIds = branchId
                ? [parseInt(branchId)]
                : this.state.branches.map((b) => parseInt(b.id)).filter((id) => !isNaN(id));
            if (!branchIds.length) { this.setState({ employees: [] }); return; }

            const results = await Promise.all(branchIds.map((branch_id) => this.props.client.query({
                query: GET_EMPLOYEES,
                variables: { institute_id, branch_id },
                fetchPolicy: "network-only",
            })));

            // A lecturer mapped to more than one in-scope branch comes back once per
            // branch — de-dupe so the Lecturer dropdown has no repeats.
            const seen = new Set();
            const empList = [];
            results.forEach((res) => {
                (res.data.getEmployees || []).forEach((e) => {
                    const key = String(e.employee_id);
                    if (seen.has(key)) return;
                    seen.add(key);
                    empList.push({ value: key, label: e.employee_name });
                });
            });

            // Auto-detect and pre-select the logged-in employee if present in employee list
            let autoSelectedId = this.state.employee_id;
            if (!autoSelectedId && loggedInEmpId) {
                const match = empList.find(e => String(e.value) === String(loggedInEmpId));
                if (match) autoSelectedId = match.value;
            }
            if (!autoSelectedId && loggedInName) {
                const match = empList.find(e => e.label.toLowerCase().includes(loggedInName.toLowerCase()));
                if (match) autoSelectedId = match.value;
            }

            this.setState({ employees: empList, employee_id: autoSelectedId || "" });
        } catch (e) {
            console.error("fetchEmployees failed", e);
        }
    };

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        let getArray = [];

        // No "branch" case — the header (NavbarOne) owns the branch selection, and
        // rebuildClassOptions() rebuilds the Class list from it.

        // Class → populate Sections from every in-scope branch, filtered by class.
        if (name === "class") {
            if (value !== "0") {
                const seen = new Set();
                this.scopedSections()
                    .filter((s) => Number(s.class_id) === Number(value))
                    .forEach((s) => {
                        if (seen.has(s.id)) return;
                        seen.add(s.id);
                        getArray.push({ value: s.id, label: s.section_name });
                    });
                this.setState({ class_id: value, exam_id: "", section_id: "", branch_id: "", noDateError: "", lecturer_time_table: [], tableHeading: [], getSections: getArray, classError: "", sectionError: "", dateError: "" });
            } else {
                this.setState({ class_id: "", exam_id: "", section_id: "", branch_id: "", noDateError: "", lecturer_time_table: [], tableHeading: [], getSections: [], classError: "", sectionError: "", dateError: "" });
            }
        }
        // Section → the section decides the branch; derive exam_id from the
        // branch + class + section combo, then load periods and section employees.
        if (name === "section") {
            if (value !== "0") {
                const derivedBranchId = this.branchIdForSection(value);
                const match = this.props.globals.b_e_c_s_data.find((item) => item.branch_id == derivedBranchId && item.class_id == this.state.class_id && item.section_id == value);
                const derivedExamId = match ? match.exam_id : "";
                this.fetchEmployees(derivedBranchId);
                this.setState(
                    { lecturer_time_table: [], tableHeading: [], noDateError: "", section_id: value, branch_id: derivedBranchId, exam_id: derivedExamId, sectionError: "" },
                    () => this.getClassPeriods()
                );
            } else {
                this.setState({ lecturer_time_table: [], tableHeading: [], noDateError: "", section_id: "", branch_id: "", exam_id: "" });
            }
        }
        // Employee / Lecturer selection filter
        if (name === "employee") {
            const selectedEmp = value === "0" ? "" : value;
            this.setState({ employee_id: selectedEmp }, () => {
                if (this.state.branch_id && this.state.class_id && this.state.section_id) {
                    this.getDisplayData();
                }
            });
        }
    };

    getClassPeriods = async () => {
        const periods = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int){
                getClassPeriodsTimings(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id){
                    period_id
                    period_name
                    period_time
                }
            }`,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id),
                exam_id: parseInt(this.state.exam_id)
            },
            fetchPolicy: 'network-only'
        });
        if (periods.data.getClassPeriodsTimings.length > 0) {
            let tableHeading = periods.data.getClassPeriodsTimings.map((item) => ({ label: item.period_name, period_id: item.period_id, period_time: item.period_time }));
            this.setState({ tableHeading });
        }
    }

    fetchTeacherTimeTableAcrossSections = async (employeeId) => {
        // Branch: the one the chosen Section belongs to, or — when no Section is
        // picked — every branch the header currently has in scope, fanned out
        // because the service takes a single branch_id.
        const branchIds = this.state.branch_id
            ? [parseInt(this.state.branch_id)]
            : this.state.branches.map((b) => parseInt(b.id)).filter((id) => !isNaN(id));
        if (!branchIds.length) return;

        this.setState({ loader: 1, noDateError: "", lecturer_time_table: [] });

        try {
            const institute_id = parseInt(Cookies.get("institutionid"));

            const results = await Promise.all(branchIds.map((branch_id) => this.props.client.query({
                query: gql`
                query($institute_id:Int!,$branch_id:Int!,$employee_id:Int!,$class_start_date:String!,$class_end_date:String){
                    getLecturerTimeTable(institute_id:$institute_id,branch_id:$branch_id,employee_id:$employee_id,class_start_date:$class_start_date,class_end_date:$class_end_date){
                        class_day_type_id
                        sub_class_day_type_id
                        class_period_id
                        period_name
                        period_time
                        subject_id
                        subject_name
                        employee_id
                        employee_name
                        class_id
                        class_name
                        section_id
                        section_name
                        class_topic
                        class_date
                        is_substituted
                        original_teacher_name
                        substitute_name
                    }
                }`,
                variables: {
                    institute_id,
                    branch_id,
                    employee_id: parseInt(employeeId),
                    class_start_date: this.state.startDateCalender.toString(),
                    class_end_date: this.state.endDateCalender.toString()
                },
                fetchPolicy: 'network-only'
            })));

            const allLecturerPeriods = results.flatMap((r) => r.data?.getLecturerTimeTable || []);

            if (allLecturerPeriods.length > 0) {
                const masterHeadingMap = new Map();
                allLecturerPeriods.forEach(h => {
                    if (h.class_period_id) {
                        masterHeadingMap.set(h.class_period_id, {
                            label: h.period_name || `P${h.class_period_id}`,
                            period_id: h.class_period_id,
                            period_time: h.period_time || ""
                        });
                    }
                });

                const tableHeading = Array.from(masterHeadingMap.values());
                const uniqueDates = [...new Set(allLecturerPeriods.map(item => item.class_date))];
                const array = uniqueDates.map((dateTs) => {
                    const dayWise = allLecturerPeriods.filter(i => i.class_date === dateTs);
                    return {
                        date: moment.unix(+dateTs).format("ddd, DD MMM YYYY"),
                        period_details: dayWise.map(i => ({
                            class_day_type_id: i.class_day_type_id,
                            class_period_id:   i.class_period_id,
                            subject_name:      i.subject_name,
                            employee_id:       i.employee_id,
                            employee_name:     i.employee_name,
                            class_topic:       i.class_topic,
                            class_name:        i.class_name,
                            section_name:      i.section_name || `Section ${i.section_id}`,
                            is_substituted:    i.is_substituted,
                            original_teacher_name: i.original_teacher_name,
                            substitute_name:   i.substitute_name
                        }))
                    };
                });
                this.setState({ lecturer_time_table: array, tableHeading, loader: 0 });
            } else {
                this.setState({ loader: 0, noDateError: "No timetable records found for this teacher." });
            }
        } catch (e) {
            console.error("fetchTeacherTimeTableAcrossSections failed", e);
            this.setState({ loader: 0, noDateError: "Error retrieving teacher timetable." });
        }
    };

    getDisplayData = async (e) => {
        if (e && e.preventDefault) e.preventDefault();

        // If an employee is explicitly selected, fetch their full schedule across
        // classes/sections. No branch_id needed up front — the helper falls back to
        // the header's whole branch scope.
        if (this.state.employee_id) {
            return this.fetchTeacherTimeTableAcrossSections(this.state.employee_id);
        }

        // No Branch check — branch_id is derived from the Section below.
        if (!this.state.class_id  || this.state.class_id  === "0") { this.setState({ classError:  "Please Select Class"  }); return; }
        if (!this.state.section_id|| this.state.section_id=== "0") { this.setState({ sectionError:"Please Select Section"}); return; }

        this.setState({ loader: 1, noDateError: "", lecturer_time_table: [] });
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int,$section_id:Int,$class_start_date:String,$class_id:Int,$class_end_date:String){
                getClassTimeTable(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,section_id:$section_id,class_start_date:$class_start_date,class_id:$class_id,class_end_date:$class_end_date){
                    class_day_type_id
                    class_period_id
                    period_name
                    period_time
                    subject_id
                    subject_name
                    employee_id
                    employee_name
                    class_id
                    class_name
                    section_id
                    section_name
                    class_topic
                    class_date
                    is_substituted
                    original_teacher_name
                    substitute_name
                }
            }`,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id:    parseInt(this.state.branch_id),
                class_id:     parseInt(this.state.class_id),
                section_id:   parseInt(this.state.section_id),
                exam_id:      parseInt(this.state.exam_id) || null,
                class_start_date: this.state.startDateCalender.toString(),
                class_end_date:   this.state.endDateCalender.toString()
            },
            fetchPolicy: 'network-only'
        });

        const rawData = result.data?.getClassTimeTable;
        if (rawData && Array.isArray(rawData) && rawData.length > 0) {
            const data = rawData;
            
            // Auto-detect employee from timetable data if not manually selected
            let activeEmpId = this.state.employee_id;
            if (!activeEmpId) {
                const loggedInId = Cookies.get("id") || Cookies.get("employee_id");
                const loggedInName = Cookies.get("username");
                const matchingPeriod = data.find(item => 
                    item && ((loggedInId && String(item.employee_id) === String(loggedInId)) ||
                    (loggedInName && item.employee_name && item.employee_name.toLowerCase().includes(loggedInName.toLowerCase())))
                );
                if (matchingPeriod && matchingPeriod.employee_id) {
                    activeEmpId = String(matchingPeriod.employee_id);
                }
            }

            const uniqueDates = [...new Set(data.map(item => item.class_date))];
            const array = uniqueDates.map((dateTs) => {
                const dayWise = data.filter(i => i.class_date === dateTs);
                return {
                    date: moment.unix(+dateTs).format("ddd, DD MMM YYYY"),
                    period_details: dayWise.map(i => ({
                        class_day_type_id: i.class_day_type_id,
                        class_period_id:   i.class_period_id,
                        subject_name:      i.subject_name,
                        employee_id:       i.employee_id,
                        employee_name:     i.employee_name,
                        class_topic:       i.class_topic,
                        class_name:        i.class_name,
                        section_name:      i.section_name || `Section ${i.section_id}`,
                        is_substituted:    i.is_substituted,
                        original_teacher_name: i.original_teacher_name,
                        substitute_name:   i.substitute_name
                    }))
                };
            });
            this.setState({ lecturer_time_table: array, employee_id: activeEmpId || this.state.employee_id, loader: 0 });
        } else {
            this.setState({ loader: 0, noDateError: "No timetable data found for the selected filters." });
        }
    };

    applyCallback = (startDate, endDate) => {
        this.setState({
            branch_id: "", class_id: "", exam_id: "", section_id: "",
            lecturer_time_table: [], tableHeading: [], noDateError: "",
            startDateCalender: startDate.startOf('day').unix(),
            endDateCalender:   endDate.startOf('day').unix(),
            getClasses: [], getSections: [],
        });
    }

    classifyStatus = (startStr, endStr) => {
        if (!startStr || !endStr) return "upcoming";
        const now = moment();
        const start = moment(startStr, "HH:mm");
        const end = moment(endStr, "HH:mm");
        start.date(now.date()).month(now.month()).year(now.year());
        end.date(now.date()).month(now.month()).year(now.year());

        if (now.isBefore(start)) return "upcoming";
        if (now.isAfter(end)) return "done";
        return "now";
    };

    buildDaySchedule = (todayRow, role = this.state.scheduleRole, selectedEmpId = this.state.employee_id) => {
        const { tableHeading } = this.state;
        let rawPeriods = todayRow ? todayRow.period_details : [];

        // ── Dedicated Lecturer Filtering ─────────────────────────────────────
        if (role === "teacher" || selectedEmpId) {
            const targetEmpId = selectedEmpId || Cookies.get("employee_id") || Cookies.get("userid");
            const targetEmpName = Cookies.get("username");

            rawPeriods = rawPeriods.filter((p) => {
                const empList = String(p.employee_id || "").split(",");
                if (selectedEmpId) return empList.includes(String(selectedEmpId));
                if (targetEmpId && p.employee_id) return empList.includes(String(targetEmpId));
                if (targetEmpName && p.employee_name) {
                    return p.employee_name.toLowerCase().includes(targetEmpName.toLowerCase());
                }
                return true;
            });
        }

        // 1. Resolve period timings and sort chronologically
        const periodsWithTime = rawPeriods.map(p => {
            const heading = tableHeading.find(h => h.period_id === p.class_period_id);
            const [startStr, endStr] = (heading?.period_time || "00:00-00:00").split("-");
            const start = startStr ? startStr.trim() : "00:00";
            const end = endStr ? endStr.trim() : "00:00";
            return {
                ...p,
                start,
                end,
                periodName: heading?.label || `P${p.class_period_id}`
            };
        }).sort((a, b) => a.start.localeCompare(b.start));

        // 2. Build schedule and inject breaks dynamically from gaps
        const daySchedule = [];
        let idx = 1;

        periodsWithTime.forEach((p, index) => {
            if (index > 0) {
                const prev = periodsWithTime[index - 1];
                if (prev.end && p.start && prev.end !== p.start) {
                    const prevM = moment(prev.end, "HH:mm");
                    const currM = moment(p.start, "HH:mm");
                    const diffMin = currM.diff(prevM, "minutes");
                    if (diffMin > 0) {
                        const breakLabel = diffMin >= 40 ? "Lunch Break" : "Short Break";
                        const status = this.classifyStatus(prev.end, p.start);
                        daySchedule.push({
                            id: `break-${index}`,
                            periodNo: "",
                            start: prev.end,
                            end: p.start,
                            duration: `${diffMin} min`,
                            subject: breakLabel,
                            status: status === "now" ? "live-break" : "break"
                        });
                    }
                }
            }

            let durationStr = "";
            if (p.start && p.end) {
                const startM = moment(p.start, "HH:mm");
                const endM = moment(p.end, "HH:mm");
                const diff = endM.diff(startM, "minutes");
                durationStr = diff > 0 ? `${diff} min` : "";
            }

            const locationStr = [p.class_name, p.section_name].filter(Boolean).join(" · ") || p.class_topic || "Own Classroom";
            daySchedule.push({
                id: p.class_period_id || idx++,
                periodNo: p.periodName,
                start: p.start,
                end: p.end,
                duration: durationStr,
                subject: p.subject_name || "Free Period",
                code: p.class_topic || "",
                teacherName: p.employee_name || "Unassigned",
                teacherInitials: p.employee_name ? p.employee_name.split(" ").map(s => s[0]).join("").slice(0, 2).toUpperCase() : "?",
                room: locationStr,
                status: this.classifyStatus(p.start, p.end)
            });
        });

        return daySchedule;
    };

    buildMonthMatrix = () => {
        const { lecturer_time_table } = this.state;
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth();
        const todayDay = now.getDate();

        const first = new Date(year, month, 1);
        const firstWeekday = (first.getDay() + 6) % 7; // Mon=0..Sun=6
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const prevMonthDays = new Date(year, month, 0).getDate();

        const cells = [];
        // leading days
        for (let i = firstWeekday - 1; i >= 0; i--) {
            cells.push({ day: prevMonthDays - i, inMonth: false });
        }
        // in-month days
        for (let d = 1; d <= daysInMonth; d++) {
            const dateStr = moment(new Date(year, month, d)).format("ddd, DD MMM YYYY");
            const dayRow = lecturer_time_table.find(r => r.date === dateStr);
            const dayType = dayRow?.period_details[0]?.class_day_type_id;

            const periodsCount = dayRow && dayType !== 2 && dayType !== 4 ? dayRow.period_details.length : 0;
            cells.push({
                day: d,
                inMonth: true,
                isToday: d === todayDay,
                periods: periodsCount,
                holiday: dayType === 4,
                hasExam: dayType === 2,
                hasEvent: dayType === 3
            });
        }
        // trailing days
        while (cells.length % 7 !== 0 || cells.length < 42) {
            cells.push({ day: cells.length - (firstWeekday + daysInMonth) + 1, inMonth: false });
            if (cells.length >= 42) break;
        }

        const matrix = [];
        for (let i = 0; i < cells.length; i += 7) matrix.push(cells.slice(i, i + 7));
        return matrix;
    };

    buildUpcomingEvents = () => {
        const { lecturer_time_table } = this.state;
        const now = moment().startOf('day');
        const events = [];
        lecturer_time_table.forEach(day => {
            const dayMoment = moment(day.date, "ddd, DD MMM YYYY");
            if (dayMoment.isSameOrAfter(now)) {
                const dayType = day.period_details[0]?.class_day_type_id;
                const classTopic = day.period_details[0]?.class_topic || "";
                if (dayType === 2 || dayType === 4 || dayType === 3) {
                    const typeLabel = dayType === 2 ? "Exam Day" : dayType === 4 ? "Holiday" : "Event Day";
                    const diffDays = dayMoment.diff(now, 'days');
                    events.push({
                        day: dayMoment.format("DD"),
                        month: dayMoment.format("MMM").toUpperCase(),
                        title: classTopic || typeLabel,
                        subtitle: typeLabel,
                        inDays: diffDays === 0 ? "today" : `${diffDays}d`
                    });
                }
            }
        });
        return events.slice(0, 4);
    };

    // ── Day-type pill used inside the datatables ──────────────────────────────
    dayTypeBadge = (dayType) => {
        const meta = DAY_TYPE_META[dayType] || DAY_TYPE_META[1];
        return (
            <span className="ltt-pill" style={{ backgroundColor: meta.bg, color: meta.color }}>
                <i className={`${meta.icon} mr-1`} />{meta.label}
            </span>
        );
    };

    // ── Flatten the day/period structure into one row per class ───────────────
    buildListRows = () => {
        const { lecturer_time_table, tableHeading, employee_id } = this.state;
        const rows = [];
        let id = 1;
        lecturer_time_table.forEach((day) => {
            const dayType = day.period_details[0]?.class_day_type_id;
            const meta = DAY_TYPE_META[dayType] || DAY_TYPE_META[1];
            const isSpecial = dayType === 2 || dayType === 4;
            if (isSpecial) {
                rows.push({
                    id: id++, date: day.date, day_type: dayType,
                    period_name: "—", subject_name: "—", employee_name: "—",
                    class_topic: day.period_details[0]?.class_topic || meta.label,
                });
            } else {
                day.period_details.forEach((pd) => {
                    const empList = String(pd.employee_id || "").split(",");
                    if (employee_id && !empList.includes(String(employee_id))) {
                        return;
                    }
                    const col = tableHeading.find((t) => t.period_id === pd.class_period_id);
                    rows.push({
                        id: id++, date: day.date, day_type: dayType,
                        period_name: col ? col.label : pd.class_period_id,
                        subject_name: pd.subject_name || "—",
                        employee_name: pd.employee_name || "—",
                        class_topic: pd.class_topic || "—",
                    });
                });
            }
        });
        return rows;
    };

    // ── Aggregate the schedule per teacher ────────────────────────────────────
    buildTeacherRows = () => {
        const { lecturer_time_table, employee_id } = this.state;
        const map = {};
        lecturer_time_table.forEach((day) => {
            const dayType = day.period_details[0]?.class_day_type_id;
            if (dayType === 2 || dayType === 4) return; // skip exam / holiday days
            day.period_details.forEach((pd) => {
                const empList = String(pd.employee_id || "").split(",");
                if (employee_id && !empList.includes(String(employee_id))) {
                    return;
                }
                const name = pd.employee_name || "Unassigned";
                if (!map[name]) map[name] = { employee_name: name, classes: 0, subjects: new Set(), days: new Set() };
                map[name].classes += 1;
                if (pd.subject_name) map[name].subjects.add(pd.subject_name);
                map[name].days.add(day.date);
            });
        });
        return Object.values(map)
            .sort((a, b) => b.classes - a.classes)
            .map((r, i) => ({
                id: i + 1,
                employee_name: r.employee_name,
                classes: r.classes,
                subjects: [...r.subjects].join(", ") || "—",
                days: r.days.size,
            }));
    };

    // ── Finance-style tab strip ───────────────────────────────────────────────
    renderTabStrip = () => {
        const { activeTab } = this.state;
        const tabs = [
            { key: "grid", label: "Timetable Grid", icon: "fas fa-th" },
            { key: "list", label: "Detailed List", icon: "fas fa-list-ul" },
            { key: "teacher", label: "Teacher Wise", icon: "fas fa-user-tie" },
        ];
        return (
            <div className="ltt-tab-strip">
                <ul className="nav nav-tabs">
                    {tabs.map(({ key, label, icon }) => (
                        <li className="nav-item" key={key}>
                            <a
                                href="#"
                                className={`nav-link ${activeTab === key ? "active" : ""}`}
                                onClick={(e) => { e.preventDefault(); this.setState({ activeTab: key }); }}
                            >
                                <i className={`${icon} mr-2`} />{label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    // ── Tab 1: Days × Periods grid table ──────────────────────────────────────
    renderGridView = () => {
        const { lecturer_time_table, tableHeading } = this.state;
        return (
            <div className="ltt-table-card">
                <div className="table-responsive">
                    <table className="ltt-grid">
                        <thead>
                            <tr>
                                <th className="ltt-grid-datehead">Date</th>
                                {tableHeading.map((col) => (
                                    <th key={col.period_id}>
                                        <span className="ltt-period-name">{col.label}</span>
                                        {col.period_time && <span className="ltt-period-time">{col.period_time}</span>}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {lecturer_time_table.map((day, idx) => {
                                const dayType = day.period_details[0]?.class_day_type_id;
                                const isSpecial = dayType === 2 || dayType === 4;
                                const meta = DAY_TYPE_META[dayType] || DAY_TYPE_META[1];
                                return (
                                    <tr key={idx}>
                                        <td className="ltt-grid-date" style={{ borderLeft: `4px solid ${meta.color}` }}>
                                            <div className="ltt-date-text">{day.date}</div>
                                            <span className="ltt-pill" style={{ backgroundColor: meta.bg, color: meta.color }}>
                                                <i className={`${meta.icon} mr-1`} />{meta.label}
                                            </span>
                                        </td>
                                        {isSpecial ? (
                                            <td colSpan={tableHeading.length || 1} className="ltt-special-cell" style={{ backgroundColor: meta.bg, color: meta.color }}>
                                                <i className={`${meta.icon} mr-2`} />
                                                {day.period_details[0]?.class_topic || meta.label}
                                            </td>
                                        ) : (
                                            tableHeading.map((col) => {
                                                const match = day.period_details.find((pd) => pd.class_period_id === col.period_id);
                                                // Check if this slot has a saved substitution for this date (from DB or local state)
                                                const subKey = `${day.date}_${col.period_id}`;
                                                const activeSub = (match && match.is_substituted) 
                                                    ? { substitute_name: match.substitute_name || match.employee_name, original_teacher_name: match.original_teacher_name } 
                                                    : this.state.substitutionMap[subKey];
                                                return (
                                                    <td key={col.period_id} className={match ? "ltt-cell-filled" : "ltt-cell-empty"}>
                                                        {match ? (
                                                            <>
                                                                <div className="ltt-subject" style={{ color: meta.color }}>{match.subject_name}</div>
                                                                {(match.section_name || match.class_name) && (
                                                                    <div className="ltt-section-badge" title={`${match.class_name || ""} ${match.section_name || ""}`}>
                                                                        <i className="fas fa-layer-group mr-1" />
                                                                        {[match.class_name, match.section_name].filter(Boolean).join(" · ")}
                                                                    </div>
                                                                )}
                                                                {activeSub ? (
                                                                    <div className="ltt-substituted-badge">
                                                                        <i className="fas fa-exchange-alt mr-1" />
                                                                        <span className="ltt-sub-name">{activeSub.substitute_name}</span>
                                                                        <span className="ltt-sub-orig">(was: {match.employee_name})</span>
                                                                    </div>
                                                                ) : (
                                                                    <div className="ltt-teacher"><i className="fas fa-user-tie mr-1" />{match.employee_name}</div>
                                                                )}
                                                                {match.class_topic && match.class_topic !== "Own Classroom" && (
                                                                    <div className="ltt-topic" title={match.class_topic}><i className="fas fa-book mr-1" />{match.class_topic}</div>
                                                                )}
                                                                {this.guard.canEdit() && (
                                                                    <button
                                                                        className="ltt-substitute-btn"
                                                                        title="Assign Substitute Teacher for this period"
                                                                        onClick={() => this.openSubstituteModal(day, match, col)}
                                                                    >
                                                                        <i className="fas fa-exchange-alt mr-1" />
                                                                        {activeSub ? "Change Sub" : "Substitute"}
                                                                    </button>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <span className="ltt-free"><i className="fas fa-minus mr-1" />Free</span>
                                                        )}
                                                    </td>
                                                );
                                            })
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    // ── Tab 2: Detailed list (searchable datatable) ───────────────────────────
    renderListView = () => {
        const rows = this.buildListRows();
        const columns = [
            { dataField: "date", text: "Date", sort: true },
            { dataField: "day_type", text: "Day Type", sort: true, formatter: (cell) => this.dayTypeBadge(cell) },
            { dataField: "period_name", text: "Period", sort: true },
            { dataField: "subject_name", text: "Subject", sort: true, formatter: (cell) => <span className="font-weight-bold">{cell}</span> },
            { dataField: "employee_name", text: "Teacher", sort: true },
            { dataField: "class_topic", text: "Topic", sort: true },
        ];
        return (
            <div className="ltt-table-card ltt-datatable">
                <CardLessDataTable
                    parentData={rows}
                    particlecolumns={columns}
                    name="lecturer_timetable_list"
                    searchBar={true}
                    placeholder="Search by date, subject, teacher..."
                />
            </div>
        );
    };

    // ── Tab 3: Teacher-wise summary (searchable datatable) ────────────────────
    renderTeacherView = () => {
        const rows = this.buildTeacherRows();
        const columns = [
            { dataField: "employee_name", text: "Teacher", sort: true, formatter: (cell) => <span className="font-weight-bold"><i className="fas fa-user-tie mr-2" style={{ color: "#6366f1" }} />{cell}</span> },
            { dataField: "classes", text: "Classes", sort: true, align: "center" },
            { dataField: "days", text: "Days Active", sort: true, align: "center" },
            { dataField: "subjects", text: "Subjects", sort: true },
        ];
        return (
            <div className="ltt-table-card ltt-datatable">
                <CardLessDataTable
                    parentData={rows}
                    particlecolumns={columns}
                    name="lecturer_timetable_teacher_wise"
                    searchBar={true}
                    placeholder="Search by teacher or subject..."
                />
            </div>
        );
    };

    // ── Substitution modal handlers ────────────────────────────────────────
    openSubstituteModal = (day, match, col) => {
        this.setState({
            showSubstituteModal: true,
            substituteTargetPeriod: {
                displayDate: day.date,
                apiDate: moment(day.date, "ddd, DD MMM YYYY").format("YYYY-MM-DD"),
                class_period_id: col.period_id,
                slot_id: col.period_id,
                original_teacher_id: match.employee_id ? parseInt(match.employee_id) : null,
                original_teacher_name: match.employee_name || "",
                subject_name: match.subject_name || "",
                timetable_id: match.timetable_id || 0,
                day_of_week: moment(day.date, "ddd, DD MMM YYYY").isoWeekday(),
            },
            selectedSubstituteEmpId: "",
            substitutionReason: "",
            substitutionError: "",
        });
    };

    submitSubstitution = async () => {
        const { substituteTargetPeriod, selectedSubstituteEmpId, substitutionReason, substitutionMap } = this.state;
        if (!selectedSubstituteEmpId) {
            this.setState({ substitutionError: "Please select a substitute teacher." });
            return;
        }
        this.setState({ substitutionLoading: true, substitutionError: "" });
        try {
            const institute_id = parseInt(Cookies.get("institutionid"));
            await this.props.client.mutate({
                mutation: SAVE_TIMETABLE_SUBSTITUTION,
                variables: {
                    params: {
                        institute_id,
                        timetable_id: substituteTargetPeriod.timetable_id || 0,
                        substitution_date: substituteTargetPeriod.apiDate,
                        day_of_week: substituteTargetPeriod.day_of_week,
                        slot_id: substituteTargetPeriod.slot_id,
                        original_teacher_id: substituteTargetPeriod.original_teacher_id,
                        substitute_id: parseInt(selectedSubstituteEmpId),
                        reason: substitutionReason || null,
                        status: "approved",
                    }
                }
            });
            // Update local badge map so the UI reflects the sub immediately
            const subKey = `${substituteTargetPeriod.displayDate}_${substituteTargetPeriod.slot_id}`;
            const subName = (this.state.employees.find(e => String(e.value) === String(selectedSubstituteEmpId))?.label) || "Substitute";
            this.setState({
                substitutionLoading: false,
                showSubstituteModal: false,
                substitutionMap: {
                    ...substitutionMap,
                    [subKey]: { substitute_id: parseInt(selectedSubstituteEmpId), substitute_name: subName }
                }
            });
        } catch (err) {
            console.error("saveTimetableSubstitution failed", err);
            this.setState({ substitutionLoading: false, substitutionError: "Failed to save substitution. Please try again." });
        }
    };

    // ── Substitution Modal ────────────────────────────────────────────────────
    renderSubstituteModal = () => {
        const {
            showSubstituteModal, substituteTargetPeriod, selectedSubstituteEmpId,
            substitutionReason, substitutionLoading, substitutionError, employees
        } = this.state;
        if (!showSubstituteModal || !substituteTargetPeriod) return null;

        return (
            <div className="ltt-modal-overlay" onClick={() => this.setState({ showSubstituteModal: false })}>
                <div className="ltt-modal-box" onClick={e => e.stopPropagation()}>
                    <div className="ltt-modal-header">
                        <span className="ltt-modal-title">
                            <i className="fas fa-exchange-alt mr-2" style={{ color: "#7c3aed" }} />
                            Assign Substitute Teacher
                        </span>
                        <button className="ltt-modal-close" onClick={() => this.setState({ showSubstituteModal: false })}>
                            <i className="fas fa-times" />
                        </button>
                    </div>

                    <div className="ltt-modal-body">
                        <div className="ltt-modal-info-row">
                            <span className="ltt-modal-info-label">Date</span>
                            <span className="ltt-modal-info-val">{substituteTargetPeriod.displayDate}</span>
                        </div>
                        <div className="ltt-modal-info-row">
                            <span className="ltt-modal-info-label">Subject</span>
                            <span className="ltt-modal-info-val">{substituteTargetPeriod.subject_name}</span>
                        </div>
                        <div className="ltt-modal-info-row">
                            <span className="ltt-modal-info-label">Original Teacher</span>
                            <span className="ltt-modal-info-val">{substituteTargetPeriod.original_teacher_name || "—"}</span>
                        </div>

                        <div className="ltt-modal-field">
                            <label className="ltt-modal-field-label">Substitute Teacher <span style={{ color: "#dc2626" }}>*</span></label>
                            <select
                                className="ltt-modal-select"
                                value={selectedSubstituteEmpId}
                                onChange={e => this.setState({ selectedSubstituteEmpId: e.target.value, substitutionError: "" })}
                            >
                                <option value="">— Select Teacher —</option>
                                {employees
                                    .filter(e => String(e.value) !== String(substituteTargetPeriod.original_teacher_id))
                                    .map(e => (
                                        <option key={e.value} value={e.value}>{e.label}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className="ltt-modal-field">
                            <label className="ltt-modal-field-label">Reason <span style={{ color: "#94a3b8", fontWeight: 400 }}>(optional)</span></label>
                            <textarea
                                className="ltt-modal-textarea"
                                rows={2}
                                placeholder="e.g. Medical leave, Conference..."
                                value={substitutionReason}
                                onChange={e => this.setState({ substitutionReason: e.target.value })}
                            />
                        </div>

                        {substitutionError && (
                            <div className="ltt-modal-error">
                                <i className="fas fa-exclamation-circle mr-1" />{substitutionError}
                            </div>
                        )}
                    </div>

                    <div className="ltt-modal-footer">
                        <button
                            className="ltt-modal-cancel"
                            onClick={() => this.setState({ showSubstituteModal: false })}
                            disabled={substitutionLoading}
                        >
                            Cancel
                        </button>
                        <button
                            className="ltt-modal-save"
                            onClick={this.submitSubstitution}
                            disabled={substitutionLoading}
                        >
                            {substitutionLoading ? (
                                <><i className="fas fa-spinner fa-spin mr-1" />Saving...</>
                            ) : (
                                <><i className="fas fa-check mr-1" />Save Substitution</>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        // is_view === 0 → block the whole page. Above every state dereference and the
        // filter/table markup so no timetable data is rendered; componentDidMount already
        // skipped the fetches.
        if (!this.guard.canView()) {
            return <AccessDeniedCard message="You do not have permission to view the Lecturer Timetable." />;
        }

        const { lecturer_time_table, loader, noDateError, periodCreationModal, timeTableCreationModal } = this.state;
        const todayRow = lecturer_time_table.find(r => r.date === moment().format("ddd, DD MMM YYYY"));

        return (
            <section className="schedule-page">

                {/* ── Page Header ────────────────────────────────── */}
                <div className="schedule-header">
                    <div className="schedule-header-left">
                        <i className="fas fa-calendar-alt schedule-header-icon" />
                        <div>
                            <h5 className="schedule-title">Lecturers TimeTable</h5>
                        </div>
                    </div>
                </div>

                {/* ── Filters ─────────────────────────────────────── */}
                <div className="schedule-filter-panel">
                    <Form onSubmit={this.getDisplayData}>
                        <Form.Row className="align-items-end">
                            {/* No Branch filter — the header's branch selection scopes this page. */}

                            <Form.Group as={Col} lg={2} md={4} sm={12} className="mb-2">
                                <Form.Label className="filter-label">Class</Form.Label>
                                <SelectDropdown
                                    options={this.state.getClasses}
                                    value={this.state.class_id}
                                    placeholder="Select Class"
                                    onSelect={(val) => this.handleInputChange({ target: { name: "class", value: String(val) } })}
                                />
                                {this.state.classError && <small className="text-danger">{this.state.classError}</small>}
                            </Form.Group>

                            <Form.Group as={Col} lg={2} md={4} sm={12} className="mb-2">
                                <Form.Label className="filter-label">Section</Form.Label>
                                <SelectDropdown
                                    options={this.state.getSections}
                                    value={this.state.section_id}
                                    placeholder="Select Section"
                                    onSelect={(val) => this.handleInputChange({ target: { name: "section", value: String(val) } })}
                                />
                                {this.state.sectionError && <small className="text-danger">{this.state.sectionError}</small>}
                            </Form.Group>

                            <Form.Group as={Col} lg={2} md={4} sm={12} className="mb-2">
                                <Form.Label className="filter-label">Lecturer / Teacher</Form.Label>
                                <SelectDropdown
                                    options={[{ value: "", label: "All Lecturers" }, ...this.state.employees]}
                                    value={this.state.employee_id}
                                    placeholder="All Lecturers"
                                    onSelect={(val) => this.handleInputChange({ target: { name: "employee", value: String(val) } })}
                                />
                            </Form.Group>

                            <Form.Group as={Col} lg={2} md={4} sm={12} className="mb-2">
                                <Form.Label className="filter-label">Date Range</Form.Label>
                                <div className="customDate">
                                    <DateBlock
                                        applyCallback={this.applyCallback}
                                        start={this.start}
                                        end={this.end}
                                        stateData={this.props.stateData}
                                    />
                                </div>
                            </Form.Group>

                            <Form.Group as={Col} lg={2} md={4} sm={12} className="mb-2">
                                <Form.Label className="filter-label">&nbsp;</Form.Label>
                                <button type="button" className="btn w-100 filter-submit-btn" onClick={this.getDisplayData}>
                                    <i className="fas fa-search mr-1" /> Get TimeTable
                                </button>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </div>

                {/* ── Content ──────────────────────────────────────── */}
                <div className="schedule-content">

                    {/* Calendar-style schedule preview (Student / Lecturer toggle). */}
                    <AcademiaSchedule
                        role={this.state.scheduleRole}
                        onRoleChange={(newRole) => this.setState({ scheduleRole: newRole })}
                        personName={
                            this.state.employee_id
                                ? (this.state.employees.find(e => String(e.value) === String(this.state.employee_id))?.label || "")
                                : Cookies.get("username") || ""
                        }
                        daySchedule={this.buildDaySchedule(todayRow, this.state.scheduleRole, this.state.employee_id)}
                        monthMatrix={this.buildMonthMatrix()}
                        upcoming={this.buildUpcomingEvents()}
                    />

                    {/* Loading — finance-style skeleton */}
                    {loader === 1 && <LecturerTimeTableShimmer rows={5} cols={5} />}

                    {/* No data */}
                    {noDateError && loader !== 1 && (
                        <div className="schedule-state-box">
                            <i className="fas fa-calendar-times schedule-state-icon text-muted" />
                            <h6 className="text-muted mt-3">{noDateError}</h6>
                        </div>
                    )}

                    {/* Tabbed table views (finance style) */}
                    {lecturer_time_table.length > 0 && loader !== 1 && (
                        <>
                            {this.renderTabStrip()}
                            <div className="ltt-tab-content">
                                {this.state.activeTab === "grid" && this.renderGridView()}
                                {this.state.activeTab === "list" && this.renderListView()}
                                {this.state.activeTab === "teacher" && this.renderTeacherView()}
                            </div>
                        </>
                    )}
                </div>

                <PeriodCreationModal
                    globals={this.props.globals}
                    stateData={this.state}
                    show={periodCreationModal}
                    onHide={() => this.setState({ periodCreationModal: false })}
                />

                <TimeTableCreationModal
                    globals={this.props.globals}
                    stateData={this.state}
                    show={timeTableCreationModal}
                    onHide={() => this.setState({ timeTableCreationModal: false })}
                />

                {/* Raised by the gated Create openers when is_edit is missing. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />

                {/* ── Teacher Substitution Modal ────────────────────────── */}
                {this.renderSubstituteModal()}
            </section>
        );
    }
}

export default withRouter(withApollo(LecturerTimeTableHome));
